import { NivelAlocacaoMembroEnum } from '../generated/backend-enums.js';
export { NivelAlocacaoMembroEnum };
export const NivelAlocacaoMembroEnumMap = {
    [NivelAlocacaoMembroEnum.JOB]: 'Job',
    [NivelAlocacaoMembroEnum.PLANILHA]: 'Planilha',
};
